/** @registry Canonical max lengths for workflow text inputs; pass to a Mantine input `maxLength` and to characterCount. */
export const FIELD_LIMITS = { singleLine: 255, narrative: 4000 } as const;

/** @registry Builds a "123 / 4000" counter string for a Mantine input `description`; pair with FIELD_LIMITS. */
export const characterCount = (
  value: string | null | undefined,
  max: number,
): string => `${value?.length ?? 0} / ${max}`;
